import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles, useTheme } from "@material-ui/core/styles";
import EntryBubble from "./EntryBubble";
import CardContent from "@material-ui/core/CardContent";
import axios, { discussionClient, taxServiceClient } from "../../AxiosClient";
import IconVisibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import CardHeader from "@material-ui/core/CardHeader";
import Pagination from "@material-ui/lab/Pagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import SpeedDial from "@material-ui/lab/SpeedDial";
import Typography from "@material-ui/core/Typography";
import Portal from "@material-ui/core/Portal";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import CreateEntry from "./CreateEntry";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import LinkIcon from "@material-ui/icons/Link";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { withSnackbar } from "notistack";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import {
  mdiFileDocumentEditOutline,
  mdiFileCheckOutline,
  mdiCheckCircleOutline,
  mdiCommentOutline,
  mdiFileMoveOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import CardList from "../../core-elements/CardList";
import ItemRequiredReadingDocument from "../list-item/ItemRequiredReadingDocument";
import ItemDocument from "../list-item/ItemDocument";
import FilterWrapper from "../filter/FilterWrapper";
import moment from "moment";
import DisplayUser from "../user/DisplayUser";
import { DragDropContext } from "react-beautiful-dnd";
import "../../sa-icons.css";
import MoveExpertQuestion from "../expert-questions/MoveExpertQuestion";
const drawerWidth = 350;
const styles = (theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: "100%",
    overflow: "visisble",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    textOverflow: "ellipsis",
    height: "100%",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    textOverflow: "ellipsis",
    width: 0,
    position: "relative",
    height: "100%",
  },
});
export class DiscussionEntries extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      entries: [],
      totalEntries: 0,
      totalPages: 0,
      editEntry: false,
      editingEntry: null,
      entryPage: 0,
      speedDialOpen: false,
      confirmLockDialogOpen: false,
      linkDialogOpen: false,
      linkDocuments: [],
      documentsAnsweringQuestion: [],
      lockingUser: {},
      openMoveExpertQuestion: false,
      filters: {
        sort: "createdDate",
        sortDirection: "DESC",
        draft: "Live",
        titleContains: "",
        favourited: false,
        liked: false,
        viewed: false,
        modifiedSinceLastSeen: false,
        onlyCreatedRecently: false,
        modifiedInLast: 0,
        taxonomyDialogOpen: false,
        createdBy: [],
        modifiedBy: [],
        taxonomy: [],
        createdStart: "",
        createdEnd: "",
        modifiedStart: "",
        modifiedEnd: "",
      },
    };
  }
  componentDidMount() {
    this.getEntries();
    this.fetchAnsweringDocuments();
    this.getLockingUser();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.discussionId != prevProps.discussionId) {
      this.getEntries();
    }
    if (this.props.discussion !== prevProps.discussion) {
      this.fetchAnsweringDocuments();
      this.getLockingUser();
    }
  }
  getLockingUser = () => {
    if (this.props.discussion.locked && this.props.discussion.lockedBy) {
      taxServiceClient
        .get(`/user/${this.props.discussion.lockedBy}`, {
          withCredentials: true,
        })
        .then((res) => {
          this.setState({ lockingUser: res.data });
        });
    }
  };
  fetchAnsweringDocuments = () => {
    let docs = this.props.discussion.documentsAnsweringQuestion;
    if (docs && docs.length > 0) {
      let promises = [];
      docs.forEach((docId) => {
        promises.push(
          axios.get(`/document/${docId}`, { withCredentials: true })
        );
      });
      Promise.all(promises)
        .then((res) => {
          this.setState({
            documentsAnsweringQuestion: res.map((res) => res.data),
          });
        })
        .catch((err) => {
          this.props.enqueueSnackbar(
            this.props.t("error_occurred_getting_answering_documents"),
            {
              variant: "error",
            }
          );
        });
    }
  };
  onFilterChange = (filter) => {
    if (filter.hasOwnProperty("taxonomy") === true) {
      if (
        filter.taxonomy.filter(
          (ele) =>
            ele.type === "taxonomy" &&
            ele.parentList &&
            ele.parentList.length === 0
        ).length > 0
      ) {
        filter.taxonomy = [];
      }
    }
    this.setState({
      filters: filter,
    });
  };

  lockUnlockDiscussion = () => {
    discussionClient
      .patch(`/discussion/${this.props.discussionId}`, {
        locked: !this.props.discussion.locked,
      })
      .then((res) => {
        this.setState({ confirmLockDialogOpen: false });
        this.props.enqueueSnackbar(
          res.data.locked
            ? this.props.t("discussion_locked_success")
            : this.props.t("discussion_unlocked_success"),
          {
            variant: "success",
          }
        );
        this.props.updateDiscussion &&
          this.props.updateDiscussion(res.data, true);
      })
      .catch((err) => {
        this.props.enqueueSnackbar(this.props.t("error_occurred_generic"), {
          variant: "error",
        });
      });
  };
  linkDocument = () => {
    discussionClient
      .post(`/expertquestion/${this.props.discussionId}/resolve`, {
        expertQuestionId: this.props.discussionId,
        resolvingDocuments: this.state.linkDocuments.map(
          (doc) => doc.documentID
        ),
      })
      .then((res) => {
        this.setState({ linkDialogOpen: false });
        this.props.enqueueSnackbar(
          this.props.t("discussion_resolved_success"),
          {
            variant: "success",
          }
        );
        this.props.updateDiscussion(res.data, true);
      })
      .catch(() => {
        this.props.enqueueSnackbar(this.props.t("error_occurred_generic"), {
          variant: "error",
        });
      });
  };
  onDocumentSelected = (doc) => {
    if (
      this.state.linkDocuments.filter((d) => d.documentID === doc.documentID)
        .length === 0
    ) {
      this.setState({ linkDocuments: [...this.state.linkDocuments, doc] });
    } else {
      this.setState({
        linkDocuments: this.state.linkDocuments.filter(
          (d) => d.documentID !== doc.documentID
        ),
      });
    }
  };
  newEntryClick = () => {
    if (
      !this.props.discussion.locked &&
      (!this.props.discussion.documentsAnsweringQuestion ||
        this.props.discussion.documentsAnsweringQuestion.length === 0)
    ) {
      this.setState({ openCreateEntry: true });
    }
  };
  render() {
    const { classes } = this.props;
    let visibiity = "";
    this.props.discussion &&
    this.props.discussion.expertQuestionVisibility &&
    this.props.discussion.expertQuestionVisibility === "PUBLIC_VIEW_AND_WRITE"
      ? (visibiity = this.props.t("public_view_and_write"))
      : this.props.discussion &&
        ((this.props.discussion.expertQuestionVisibility &&
          this.props.discussion.expertQuestionVisibility === "EXPERT_ONLY") ||
          (this.props.discussion.expert === true ||
            this.props.discussion.type === "KNOWLEDGE_ITEM"))
        ? (visibiity = this.props.t("expert_only"))
        : (visibiity = this.props.t("global_public"));
    let canModerate =
      this.props.user.userPermits.roles.forumModerator ||
      this.props.user.userPermits.roles.administrator ||
      this.props.user.userPermits.roles.administrator.systemManager;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        {!this.props.noheader && (
          <CardHeader
            titleTypographyProps={{ component: "h3" }}
            title={this.props.discussion.title}
            avatar={this.props.avatar}
            action={this.props.action}
          />
        )}
        <div
          style={{
            display: "flex",
            flex: 1,
            height: "calc(100% - 72px)",
            flexDirection: "column",
            position: "relative",
            overflowWrap: "anywhere",
          }}
        >
          {this.state.openCreateEntry && (
            <Portal>
              <CreateEntry
                top={10}
                onEntryCreated={this.getEntries}
                changeOpenCreateEntry={() =>
                  this.setState({ openCreateEntry: false, editingEntry: null })
                }
                edit={this.state.editEntry}
                onEntryEdited={(newEntry) => {
                  let newEntries = this.state.entries.map((entry) => {
                    if (newEntry.entryId === entry.entryId) {
                      return newEntry;
                    } else {
                      return entry;
                    }
                  });
                  this.setState({
                    entries: newEntries,
                    editEntry: false,
                    editingEntry: null,
                  });
                }}
                entry={this.state.editingEntry}
                discussion={this.props.discussion}
                open={this.state.openCreateEntry}
              />
            </Portal>
          )}
          {this.props.discussion && (
            <FormControl component="fieldset" className={classes.formControl}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "59px",
                }}
              >
                <IconVisibility />
                <span> &nbsp;</span> <div>{visibiity}</div>
              </div>
            </FormControl>
          )}
          <CardContent
            data-testid="discussion-entry-container"
            style={{
              display: "flex",
              flex: 1,
              height: "100%",
              flexDirection: "column",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            {this.state.entries.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "100%",
                }}
              >
                <div style={{ display: "flex", width: "100%" }} />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", height: "100%" }} />
                  <CircularProgress
                    size={100}
                    className="add-choice-dialog-spinner"
                  />
                  <div style={{ display: "flex", height: "100%" }} />
                </div>
                <div style={{ display: "flex", width: "100%" }} />
              </div>
            ) : (
              <>
                {!!this.props.discussion.documentsAnsweringQuestion &&
                  this.props.discussion.documentsAnsweringQuestion.length >
                    0 && (
                    <div
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid rgb(212, 212, 212)",
                        borderRadius: 10,
                        padding: 5,
                        marginBottom: 10,
                        paddingRight: 10,
                      }}
                      id="answering-questions"
                    >
                      <Icon
                        path={mdiCheckCircleOutline}
                        size={3}
                        color="#a5dc86"
                      />
                      <div style={{ marginLeft: 10 }}>
                        <Typography style={{ fontWeight: "bold" }} gutterBottom>
                          {this.props.t(
                            "expert_question_answered_by_documents"
                          )}
                        </Typography>
                        {this.state.documentsAnsweringQuestion.map((doc) => (
                          <ItemDocument noIcons data={doc} />
                        ))}
                      </div>
                    </div>
                  )}
                {this.props.discussion.locked && (
                  <Typography
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      fontStyle: "italic",
                    }}
                  >
                    {this.props.t("discussion_locked", {
                      interpolation: {
                        escapeValue: false,
                      },
                      user: this.state.lockingUser.userLogin
                        ? this.state.lockingUser.firstName +
                          " " +
                          this.state.lockingUser.surname +
                          " (" +
                          this.state.lockingUser.userLogin +
                          ")"
                        : "Unknown",
                      date: moment(this.props.discussion.dateLocked).format(
                        "DD/MM/YYYY HH:mm"
                      ),
                    })}
                  </Typography>
                )}
                {this.state.entries.map((entry, idx) => {
                  return (
                    <EntryBubble
                      isMyMessage={entry.userId === this.props.user.userId}
                      expert={
                        this.props.discussion &&
                        this.props.discussion.genre === "EXPERT_QUESTION" &&
                        idx === 0
                      }
                      editEntry={(entry) =>
                        this.setState({
                          openCreateEntry: true,
                          editingEntry: entry,
                          editEntry: true,
                        })
                      }
                      key={entry.entryId}
                      entry={entry}
                      removeEntry={this.getEntries}
                    />
                  );
                })}
              </>
            )}
          </CardContent>
          {this.state.totalPages > 1 && (
            <Pagination
              style={{ margin: 8, alignSelf: "center" }}
              count={this.state.totalPages}
              onChange={this.changePage}
              color="primary"
            />
          )}
          <Tooltip
            title={
              this.props.discussion.locked ? (
                <Typography>
                  {this.props.t("cannot_add_entry_locked")}
                </Typography>
              ) : (
                <Typography>{this.props.t("add_entry_tooltip")}</Typography>
              )
            }
            placement="left-end"
          >
            <SpeedDial
              ariaLabel="Create entry"
              onClick={this.newEntryClick}
              color="primary"
              disabled={this.props.discussion.locked}
              FabProps={{
                disableRipple: this.props.discussion.locked,
                disableFocusRipple: this.props.discussion.locked,
              }}
              onOpen={() => this.setState({ speedDialOpen: true })}
              onClose={() => this.setState({ speedDialOpen: false })}
              open={this.state.speedDialOpen}
              icon={
                this.props.discussion.locked ? (
                  <LockIcon />
                ) : (
                  <Icon path={mdiCommentOutline} size={1} />
                )
              }
              style={{
                position: "absolute",
                bottom: 10,
                right: 10,
              }}
            >
              {this.props.discussion &&
                this.props.discussion.genre === "EXPERT_QUESTION" &&
                this.props.user.userPermits.roles.beExpert && (
                  <SpeedDialAction
                    aria-label="Resolve question with document"
                    disabled={
                      (!!this.props.discussion.documentsAnsweringQuestion &&
                        this.props.discussion.documentsAnsweringQuestion
                          .length > 0) ||
                      this.props.user.userType === "limited"
                    }
                    icon={<Icon path={mdiFileCheckOutline} size={1} />}
                    tooltipTitle={this.props.t(
                      "resolve_question_with_document"
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ linkDialogOpen: true });
                    }}
                  />
                )}
              {this.props.discussion &&
                this.props.discussion.genre === "EXPERT_QUESTION" &&
                (this.props.discussion.postedById === this.props.user.userId ||
                  this.props.user.userPermits.roles.beExpert) && (
                  <SpeedDialAction
                    aria-label="Move expert question"
                    icon={<Icon path={mdiFileMoveOutline} size={1} />}
                    tooltipTitle={this.props.t("move_expert_question")}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ openMoveExpertQuestion: true });
                    }}
                  />
                )}
              <SpeedDialAction
                disabled={
                  !canModerate ||
                  (!!this.props.discussion.documentsAnsweringQuestion &&
                    this.props.discussion.documentsAnsweringQuestion.length >
                      0) ||
                  this.props.user.userType === "limited"
                }
                icon={
                  this.props.discussion.locked ? <LockOpenIcon /> : <LockIcon />
                }
                aria-label={
                  this.props.discussion.locked
                    ? "Unlock this discussion"
                    : "Lock this discussion"
                }
                tooltipTitle={
                  this.props.discussion.locked
                    ? this.props.t("unlock_this_discussion")
                    : this.props.t("lock_this_discussion")
                }
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ confirmLockDialogOpen: true });
                }}
              />
              {this.props.user.userPermits.roles.beExpert && (
                <SpeedDialAction
                  aria-label={this.props.t("create_content_from_discussion")}
                  icon={<Icon path={mdiFileDocumentEditOutline} size={1} />}
                  tooltipTitle={this.props.t("create_content_from_discussion")}
                  disabled={this.props.user.userType === "limited"}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.openCreateContent();
                  }}
                />
              )}
            </SpeedDial>
          </Tooltip>
          <Dialog open={this.state.openMoveExpertQuestion}>
            <MoveExpertQuestion
              expertQuestionId={this.props.discussion.discussionId}
              close={() => this.setState({ openMoveExpertQuestion: false })}
            />
          </Dialog>
          <Dialog
            maxWidth="lg"
            fullWidth
            open={this.state.linkDialogOpen}
            onClose={() => this.setState({ linkDialogOpen: false })}
            aria-labelledby="link-document-dialog"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="link-document-dialog">
              {this.props.t("resolve_question_header")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.props.t("resolve_question_body")}
              </DialogContentText>
            </DialogContent>
            <FilterWrapper
              asPopper={false}
              open={true}
              filterElement={"FilterDocuments"}
              filter={this.state.filters}
              onFilterChange={this.onFilterChange}
              isFilterBar={false}
              title={this.state.filterTitle}
              showReset={this.state.haveFiltersChanged}
              resetToDefaultFilters={this.resetToDefaultFilters}
              filterInstance={this.state.filterInstance}
              disabledFilters={["draft"]}
            />
            <div
              style={{ height: 300, marginBottom: 10 }}
              id="resolving-document-list"
            >
              <DragDropContext onDragEnd={() => {}}>
                <CardList
                  parameters={this.state.filters}
                  listItem={ItemRequiredReadingDocument}
                  isPortlet={false}
                  selectedDocuments={this.state.linkDocuments}
                  listOnly
                  onItemClick={this.onDocumentSelected}
                  portlet={{ id: Math.floor(Math.random() * 1000) + 1 }}
                  listItemTitleColumn={{
                    name: "title",
                    message: "global_document_title",
                  }}
                  messageType="com.kpsol.api.apicommon.document.DocumentInterface"
                />
              </DragDropContext>
            </div>
            <DialogActions>
              <Button
                onClick={() => this.setState({ linkDialogOpen: false })}
                color="primary"
              >
                {this.props.t("global_cancel")}
              </Button>
              <Button
                onClick={() => this.linkDocument()}
                color="primary"
                id="resolve-question-button"
                autoFocus
              >
                {this.props.t("resolve_document_action")}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.confirmLockDialogOpen}
            onClose={() => this.setState({ confirmLockDialogOpen: false })}
            aria-labelledby="confirm-lock-dialog"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="confirm-lock-dialog">
              {this.props.t("global_are_you_sure")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.props.discussion.locked
                  ? this.props.t("are_you_sure_unlock_discussion_body")
                  : this.props.t("are_you_sure_lock_discussion_body")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ confirmLockDialogOpen: false })}
                color="primary"
              >
                {this.props.t("global_cancel")}
              </Button>
              <Button
                onClick={() => this.lockUnlockDiscussion()}
                color="primary"
                autoFocus
                aria-label={
                  this.props.discussion.locked
                    ? "Unlock Discussion"
                    : "Lock Discussion"
                }
              >
                {this.props.discussion.locked
                  ? this.props.t("unlock_discussion_action")
                  : this.props.t("lock_discussion_action")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  changePage = (e, entryPage) => {
    this.setState({ entryPage: entryPage - 1, entries: [] }, () => {
      this.getEntries();
    });
  };
  getEntries = () => {
    discussionClient
      .get(`/discussion/${this.props.discussionId}/entry/`, {
        params: {
          size: 10,
          page: this.state.entryPage,
        },
        withCredentials: true,
      })
      .then((res) => {
        this.setState({
          totalPages: res.data.totalPages,
          entries: res.data.content,
        });
        this.props.updateSummary && this.props.updateSummary() 
      });
  };
}
const mapStateToProps = (state) => ({
  message: state.websocket.message,
  user: state.user.currentUser,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(withSnackbar(DiscussionEntries))));
